import {
  useEnvironment,
  useExperiments,
  useTranslation,
} from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextPriority } from 'wix-ui-tpa/cssVars';
import { SHOW_DISCOUNT_EXPERIMENT } from '../../../../../../utils/settings/consts';
import { classes, st } from './DiscountName.st.css';

export type DiscountNameProps = {
  discountName?: string;
  showCalculatedAtCheckout?: boolean;
};

export const DiscountName: FC<DiscountNameProps> = ({
  discountName,
  showCalculatedAtCheckout,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const isShowDiscountEnabled = experiments.enabled(SHOW_DISCOUNT_EXPERIMENT);

  if (!isShowDiscountEnabled || !discountName) {
    return null;
  }

  return (
    <div
      data-hook="agenda-item-discount-name"
      className={st(classes.root, { isMobile })}
    >
      <Text className={classes.discountName}>{discountName}</Text>
      {showCalculatedAtCheckout && (
        <Text
          data-hook="agenda-item-calculated-at-checkout"
          priority={TextPriority.secondary}
        >
          {t('app.discount-calculated-at-checkout')}
        </Text>
      )}
    </div>
  );
};
